import i18n from '@dms/i18n';

import {CO2_CLASS_OPTIONS} from '../constants/CO2_CLASS_OPTIONS';
import {Field} from './primitives/Field';

export function CarbonDioxideEmissionClassDischargedSelect() {
  return (
    <Field
      type="choice"
      name="carbonDioxideEmissionClassDischarged"
      label={i18n.t('entity.vehicle.labels.carbonDioxideEmissionClassDischarged')}
      options={CO2_CLASS_OPTIONS}
    />
  );
}
